<template>
  <div
    :data-tourid="tourid"
    class="d-flex align-center cursor-pointer"
    @click="showOptions = !showOptions"
  >
    <span class="subtitle-2 blue-grey--text text--darken-3">
      {{ name }}
    </span>
    <Button
      v-if="isOptionSelected"
      class="ml-3 button-max-height"
      color="grey"
      size="small"
      data-testid="explore-button-clearTypes"
      icon="mdi-close"
      plain
      :disabled="!isOptionSelected"
      @click.stop="$emit('clear')"
    />
    <v-icon v-if="showOptions" class="ml-auto" color="blue-grey darken-3"
      >mdi-chevron-up</v-icon
    >

    <v-icon v-else class="ml-auto" color="blue-grey darken-3"
      >mdi-chevron-down</v-icon
    >
  </div>
</template>

<script>
import Button from '@/components/UI/Button.vue'
export default {
  name: 'FilterTitle',

  components: { Button },

  props: {
    name: { type: String, required: true },
    isOptionSelected: Boolean,
    tourid: { type: String, default: 'filter-title' },
  },

  data() {
    return { showOptions: true }
  },

  watch: {
    showOptions() {
      this.$emit(this.showOptions ? 'show' : 'hide')
    },
  },
}
</script>
